import { registerVueWidgetForJsp } from "@/Registry";

registerVueWidgetForJsp("ActionableReflectSection", async () => 
   (await import("./widgets/ActionableReflectSection")).ActionableReflectSectionWidget
);

registerVueWidgetForJsp("ActionableActionbar", async () => 
   (await import("./widgets/ActionableActionbar")).ActionableActionbarWidget
);

registerVueWidgetForJsp("FullSearch", async () => 
   (await import("./widgets/FullSearch")).FullSearchWidget
);

registerVueWidgetForJsp("AskGetabstractWidget", async () => 
   (await import("./widgets/AskGetabstractWidget")).AskGetabstractWidgetWidget
);

registerVueWidgetForJsp("AskGetabstractIframe", async () => 
   (await import("./widgets/AskGetabstractIframe")).AskGetabstractIframeWidget
);

registerVueWidgetForJsp("AskGetabstractDemo", async () => 
   (await import("./widgets/AskGetabstractDemo")).AskGetabstractDemoWidget
);

registerVueWidgetForJsp("VerifaiCreatorPage", async () => 
   (await import("./widgets/VerifaiCreatorPage")).VerifaiCreatorPageWidget
);

registerVueWidgetForJsp("VerifaiNavigation", async () => 
   (await import("./widgets/VerifaiNavigation")).VerifaiNavigationWidget
);

registerVueWidgetForJsp("GaTopLayer", async () => 
   (await import("./widgets/GaTopLayer")).GaTopLayerWidget
);

registerVueWidgetForJsp("Warmup", async () => 
   (await import("./widgets/Warmup")).WarmupWidget
);

registerVueWidgetForJsp("WarmupDemo", async () => 
   (await import("./widgets/WarmupDemo")).WarmupDemoWidget
);

registerVueWidgetForJsp("ModalDemo", async () => 
   (await import("./widgets/ModalDemo")).ModalDemoWidget
);

registerVueWidgetForJsp("ExperimentalGeneratorDemo", async () => 
   (await import("./widgets/ExperimentalGeneratorDemo")).ExperimentalGeneratorDemoWidget
);

registerVueWidgetForJsp("GaProgressCircleDemo", async () => 
   (await import("./widgets/GaProgressCircleDemo")).GaProgressCircleDemoWidget
);

registerVueWidgetForJsp("SummaryCardDefaultDemo", async () => 
   (await import("./widgets/SummaryCardDefaultDemo")).SummaryCardDefaultDemoWidget
);

registerVueWidgetForJsp("SummaryCardCompactDemo", async () => 
   (await import("./widgets/SummaryCardCompactDemo")).SummaryCardCompactDemoWidget
);

registerVueWidgetForJsp("SummaryCardMiniDemo", async () => 
   (await import("./widgets/SummaryCardMiniDemo")).SummaryCardMiniDemoWidget
);

registerVueWidgetForJsp("FullSearchAiDemoComponent", async () => 
   (await import("./widgets/FullSearchAiDemoComponent")).FullSearchAiDemoComponentWidget
);

registerVueWidgetForJsp("MIABPage", async () => 
   (await import("./widgets/MIABPage")).MIABPageWidget
);

registerVueWidgetForJsp("BadgeDemo", async () => 
   (await import("./widgets/BadgeDemo")).BadgeDemoWidget
);

registerVueWidgetForJsp("GaFeedbackDemo", async () => 
   (await import("./widgets/GaFeedbackDemo")).GaFeedbackDemoWidget
);

registerVueWidgetForJsp("MIABOverviewPage", async () => 
   (await import("./widgets/MIABOverviewPage")).MIABOverviewPageWidget
);

registerVueWidgetForJsp("ContentCardDemo", async () => 
   (await import("./widgets/ContentCardDemo")).ContentCardDemoWidget
);

registerVueWidgetForJsp("DateFormattingDemo", async () => 
   (await import("./widgets/DateFormattingDemo")).DateFormattingDemoWidget
);

registerVueWidgetForJsp("LeadFormWidget", async () => 
   (await import("./widgets/LeadFormWidget")).LeadFormWidgetWidget
);

registerVueWidgetForJsp("LeadFormWidgetGraphConnector", async () => 
   (await import("./widgets/LeadFormWidgetGraphConnector")).LeadFormWidgetGraphConnectorWidget
);

registerVueWidgetForJsp("ExpertVideoOverviewPage", async () => 
   (await import("./widgets/ExpertVideoOverviewPage")).ExpertVideoOverviewPageWidget
);

registerVueWidgetForJsp("ExpertVideoDetailPage", async () => 
   (await import("./widgets/ExpertVideoDetailPage")).ExpertVideoDetailPageWidget
);

registerVueWidgetForJsp("SkillPage", async () => 
   (await import("./widgets/SkillPage")).SkillPageWidget
);

registerVueWidgetForJsp("ExploreSkills", async () => 
   (await import("./widgets/ExploreSkills")).ExploreSkillsWidget
);

registerVueWidgetForJsp("SummaryPageDemo", async () => 
   (await import("./widgets/SummaryPageDemo")).SummaryPageDemoWidget
);

registerVueWidgetForJsp("SummaryPage", async () => 
   (await import("./widgets/SummaryPage")).SummaryPageWidget
);

registerVueWidgetForJsp("Sharer", async () => 
   (await import("./widgets/Sharer")).SharerWidget
);

registerVueWidgetForJsp("SubscribeFunnel", async () => 
   (await import("./widgets/SubscribeFunnel")).SubscribeFunnelWidget
);

